import React from 'react';
import audioLink from '../../../../assets/audios/newMessage.mp3';
import ImageIcon from '../../../../assets/img/message.png';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import ToastFlex from 'utils/classes/ToastFlex';

const getToastPermission = () => {
  const result = localStorage.getItem('@flexuc/isNotificationsChatEnabled');
  return result === 'true';
};

const TOAST_TYPES = {
  ERROR: (props) => {
    ToastFlex.error({
      message: props.message,
      options: props.options,
      desktopProps: props.desktopProps
    });
  },
  SUCCESS: (props) => {
    ToastFlex.success({
      message: props.message,
      permission: getToastPermission(),
      action: props.action,
      options: props.options,
      desktopProps: props.desktopProps,
      audioUrl: props.audioUrl,
      playAudio: props.playAudio
    });
  },
  INFO: (props) => {
    ToastFlex.info({
      message: props.message,
      permission: getToastPermission(),
      action: props.action,
      options: props.options,
      desktopProps: props.desktopProps,
      audioUrl: props.audioUrl,
      playAudio: props.playAudio
    });
  },
  WARNING: (props) => {
    ToastFlex.warning({
      message: props.message,
      options: props.options,
      desktopProps: props.desktopProps
    });
  }
};

const ClickToastArea = ({
  name,
  idChat,
  IsNotificationScheduling,
  IsNotificationSchedulingCrm
}) => {
  const history = useHistory();

  const handlerClick = async (idChat) => {
    if (IsNotificationScheduling) {
      history.push(`/admin/protocol`, {
        idChat,
        IsNotificationScheduling: true
      });
    } else if (IsNotificationSchedulingCrm) {
      if (IsNotificationSchedulingCrm?.entity) {
        const { entity, recordTypeId, leadId, opportunityId } =
          IsNotificationSchedulingCrm;

        const basePath = `/admin/crm`;
        const paths = {
          LEAD:
            leadId && recordTypeId
              ? `${basePath}/leadEdit/${recordTypeId}/${leadId}`
              : `${basePath}/lead`,
          OPPORTUNITY:
            opportunityId && recordTypeId
              ? `${basePath}/opportunityEdit/${recordTypeId}/${opportunityId}`
              : `${basePath}/opportunity`
        };

        const path = paths[entity] || basePath;

        history.push(path);
      }
    } else {
      history.push(`/admin/service_panel`, { idChat });
    }
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        padding: '10px'
      }}
      onClick={() => {
        handlerClick(idChat)
          .then(() => {})
          .catch((error) => {
            console.log('error ==>', error);
          });
      }}
    >
      {name}
    </div>
  );
};
/**
 * Toca um som de notificação respeitando as configurações do usuário
 * salvas no localStorage (@flexuc/audioEnabled e @flexuc/audioNotificationVolume).
 */
const playNotificationSound = (audioUrl = audioLink) => {
  const audioEnabled = JSON.parse(localStorage.getItem('@flexuc/audioEnabled'));
  if (!audioEnabled) {
    return;
  }

  const audioNotificationVolume =
    localStorage.getItem('@flexuc/audioNotificationVolume') || 1;

  const audio = new Audio(audioUrl);
  audio.volume = audioNotificationVolume;
  audio.play();
};

/**
 * Reproduz um alerta de notificação com várias opções de configuração.
 */
export const PlayNewAlert = ({
  data,
  areDesktopNotificationsAllowed,
  audioNotificationURL = null,
  isNotificationScheduling = false,
  playAudio = true,
  toastData = {
    action: 'ERROR',
    message: 'Ocorreu um erro não identificado',
    type: 'ERROR',
    playAudio: true
  }
}) => {
  if (isNotificationScheduling) {
    if (data?.entity || data?.type === 'scheduling_crm') {
      const dateObject = new Date(data.createdAt);
      const offsetHours = dateObject.getUTCHours() - 3;
      const minutes = dateObject.getUTCMinutes();
      const matchTitle = data.content.match(
        /(Lead|Oportunidade) ([^p]+)(para o dia|para agora)/
      );

      const title = matchTitle ? matchTitle[2].trim() : '';

      const adjustedHours = (offsetHours + 24) % 24;

      const formattedTime = `${String(adjustedHours).padStart(2, '0')}:${String(
        minutes
      ).padStart(2, '0')}`;

      const menssageBody = `Você tem um agendamento às ${formattedTime}h referente ${
        data?.entity === 'LEAD'
          ? `ao Lead ${title}.`
          : `à Oportunidade ${title}.`
      }`;

      if (areDesktopNotificationsAllowed === 'granted') {
        const notification = new Notification('FlexUC', {
          body: menssageBody,
          icon: ImageIcon
        });
        const origin = window.location.origin;
        if (data.entity === 'LEAD') {
          notification.onclick = function () {
            window.open(
              `${origin}/admin/crm/leadEdit/${data.recordTypeId}/${data.leadId}`,
              '_blank'
            );
            window.focus();
          };
        } else if (data.entity === 'OPPORTUNITY') {
          notification.onclick = function () {
            window.open(
              `${origin}/admin/crm/opportunityEdit/${data.recordTypeId}/${data.opportunityId}`,
              '_blank'
            );
            window.focus();
          };
        }
      } else {
        toast.info(
          <ClickToastArea
            name={menssageBody}
            IsNotificationSchedulingCrm={data}
          />
        );
      }
      playNotificationSound(audioNotificationURL || audioLink);

      ToastFlex.processGroupedMessages(
        toastData.action,
        '',
        '',
        toastData.type,
        audioNotificationURL || audioLink,
        playAudio
      );
    } else {
      const dateObject = new Date(data.createdAt);
      const offsetHours = dateObject.getUTCHours() - 3;
      const minutes = dateObject.getUTCMinutes();

      const adjustedHours = (offsetHours + 24) % 24;

      const formattedTime = `${String(adjustedHours).padStart(2, '0')}:${String(
        minutes
      ).padStart(2, '0')}`;

      const protocoloRegex = /Protocolo\s*(?:N°|Nº|#)\s*([^\s.,-]+)/i;

      const match = data?.content.match(protocoloRegex);
      const protocoloNumber = match ? match[1] : null;

      const menssageBody = `Você tem um agendamento às ${formattedTime}h referente ao protocolo N° ${protocoloNumber} `;

      if (areDesktopNotificationsAllowed === 'granted') {
        const notification = new Notification('FlexUC', {
          body: menssageBody,
          icon: ImageIcon
        });
        const origin = window.location.origin;
        notification.onclick = function () {
          window.open(
            `${origin}/admin/protocol/${data.protocolId}/update`,
            '_blank'
          );
          window.focus();
        };
      } else {
        toast.info(
          <ClickToastArea
            name={menssageBody}
            idChat={data.protocolId}
            IsNotificationScheduling={true}
          />
        );
      }

      playNotificationSound(audioNotificationURL || audioLink);

      ToastFlex.processGroupedMessages(
        toastData.action,
        '',
        '',
        toastData.type,
        audioNotificationURL || audioLink,
        playAudio
      );
    }
  } else if (data?.type === 'scheduling_portalbackend_pause_exceed') {
    const audio = new Audio(audioNotificationURL);

    const audioNotificationVolume =
      localStorage.getItem('@flexuc/audioNotificationVolume') || 1;

    audio.volume = audioNotificationVolume;

    const audioEnabled = JSON.parse(
      localStorage.getItem('@flexuc/audioEnabled')
    );

    if (audioEnabled) audio.play();
  } else {
    const idDaConversa = data?.idDaConversa || data?.id || data?._id;
    // Configurar propriedades da notificação desktop
    const origin = window.location.origin;
    const desktopProps = {
      title: 'FlexUC',
      iconUrl: ImageIcon,
      desktopPermission: areDesktopNotificationsAllowed,
      onClick: function () {
        window.open(`${origin}/admin/service_panel/${idDaConversa}`, '_blank');
        window.focus();
      }
    };

    // Adicionar desktopProps ao toastData
    const enhancedToastData = {
      ...toastData,
      desktopProps,
      audioUrl: audioNotificationURL || audioLink,
      playAudio
    };

    // Usar o tipo correto de toast com dados aprimorados
    TOAST_TYPES[toastData.type ?? 'ERROR'](enhancedToastData);
  }
};
